import { RowData } from '../App';

export class Block {
    constructor(
        public name: string,
        public shouldDisplayBlockName: boolean,
        public blockNameFont: string,
        public blockNameSize: number,
        public blockNameWeight: number,
        public blockNameColor: string,
        public numColumns: number,
        public labelValueGap: number,
        public marginColumn: number,
        public edgeDistance: number,
        public distanceBetweenRows: number,
        public distanceFromPreviousBlock: number,
        public isSongBlock: boolean,
        public isSingleCell: boolean,
        public isCreditsList: boolean,
        public separator: string,
        public isLogoBlock: boolean,
        public labelFontName: string,
        public labelFontSize: number,
        public labelFontWeight: number,
        public labelAlign: string,
        public labelVerticalAlign: string,
        public labelFontColor: string,
        public valueFontName: string,
        public valueFontSize: number,
        public valueFontWeight: number,
        public valueAlign: string,
        public valueVerticalAlign: string,
        public valueFontColor: string,
        public hasSeparateValueFormatting: boolean = false,
        public dataRows: RowData[] = []
    ) {}
}

